module.exports = __webpack_public_path__ + "static/snow-659c89aa8975e1bc9420b65649b2a027.webm";